// src/utils/api.ts — Axios instance with JWT and auto-refresh
import axios from 'axios'

const BASE_URL = (import.meta as any).env?.VITE_API_URL ?? 'http://localhost:8787'

export const api = axios.create({
  baseURL: BASE_URL,
  headers: { 'Content-Type': 'application/json' },
  timeout: 8000
})

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('tp_access_token')
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

api.interceptors.response.use(
  (res) => res,
  async (err) => {
    const original = err.config
    if (err.response?.status === 401 && !original._retry) {
      original._retry = true
      const refreshToken = localStorage.getItem('tp_refresh_token')
      if (refreshToken) {
        try {
          const { data } = await axios.post(`${BASE_URL}/api/auth/refresh`, { refreshToken })
          localStorage.setItem('tp_access_token', data.accessToken)
          localStorage.setItem('tp_refresh_token', data.refreshToken)
          original.headers.Authorization = `Bearer ${data.accessToken}`
          return api(original)
        } catch {
          localStorage.removeItem('tp_access_token')
          localStorage.removeItem('tp_refresh_token')
        }
      }
    }
    return Promise.reject(err)
  }
)
